module.exports = __webpack_public_path__ + "img/img_nationwide_cultivate_village@3x.434d9ed2.png";